<table class="center-table table">
  <tr>
    <td>
      <b>{{ requestedbookI18n?.bookI18n }} :</b>
    </td>
    <td>{{ requestedbook?.book?.title }}</td>
  </tr>
  <tr>
    <td>
      <b>{{ requestedbookI18n?.writerI18n }} :</b>
    </td>
    <td>{{ requestedbook?.writer?.name }}</td>
  </tr>
  <tr>
    <td>
      <b>{{ requestedbookI18n?.ctagoryI18n }} :</b>
    </td>
    <td>{{ requestedbook?.ctagory?.category_name }}</td>
  </tr>
  <tr>
    <td>
      <b>{{ requestedbookI18n?.memberI18n }} :</b>
    </td>
    <td>{{ requestedbook?.member?.name }}</td>
  </tr>
</table>
